var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainReservations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.75 21.7056H21.75M21.75 21.7056H18.75M21.75 21.7056V18.7056M21.75 21.7056V24.7056M8.25 3.70557V1.45557M23.25 3.70557V1.45557M30 11.2056H13.875M0.75 11.2056H6.5625M18.75 30.7056H12.75C7.0935 30.7056 4.2645 30.7056 2.508 28.9476C0.7515 27.1896 0.75 24.3621 0.75 18.7056V15.7056C0.75 10.0491 0.75 7.22007 2.508 5.46357C4.266 3.70707 7.0935 3.70557 12.75 3.70557H18.75C24.4065 3.70557 27.2355 3.70557 28.992 5.46357C30.7485 7.22157 30.75 10.0491 30.75 15.7056V18.7056C30.75 24.3621 30.75 27.1911 28.992 28.9476C28.0125 29.9286 26.7 30.3621 24.75 30.5526",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainReservations);
export default __webpack_public_path__ + "static/media/mainReservations.a56d55bf1f6f06b171f49990f5fa3182.svg";
export { ForwardRef as ReactComponent };